import IconeSemInformacaoIntimacao from '@/components/IconeSemInformacaoIntimacao';
import { MEIO_JULGAMENTO_PROCESSO } from '@/dominio/MeioJulgamentoProcesso';
import { MEIO_JULGAMENTO_SESSAO } from '@/dominio/MeioJulgamentoSessao';
import SituacaoJulgamentoProcessoBusiness from '@/dominio/SituacaoJulgamentoProcessoBusiness';
import { PlaylistAddCheck, Warning } from '@mui/icons-material';
import VistaMesa from '@mui/icons-material/LocalLibrary';
import IconeAnotacoes from '@mui/icons-material/Notes';
import { Checkbox, FormControlLabel, Tooltip, Typography } from '@mui/material';
import { blue, grey } from '@mui/material/colors';
import { action, computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import Configuracao from '../../util/Configuracao';
import IconeDivergencia from '../IconeDivergencia';
import IconeOrigem from '../IconeOrigem';
import IconeRessalva from '../IconeRessalva';
import LabelNumeroProcesso from '../LabelNumeroProcesso';
import ReactComponent from '../ReactComponent';
import Apregoar from './Apregoar';
import IconeAdvogadoPreferencia from './icones/IconeAdvogadoPreferencia';
import IconeCorreJunto from './icones/IconeCorreJunto';
import IconeDestaque from './icones/IconeDestaque';
import IconeTipoJulgamento from './icones/IconeTipoJulgamento';
import IconesMagistradosProcesso from './IconesMagistradosProcesso';
import Impedimento from './Impedimento';
import PeticoesPendentes from './PeticoesPendentes';
import ResultadoJulgamento from './ResultadoJulgamento';
import StatusMinuta from './StatusMinuta';
import SustentacaoOral from './SustentacaoOral';
import VotoNaoLiberado from './VotoNaoLiberado';
import VotoRevogado from './VotoRevogado';

class CabecalhoProcessoOperacoesEmLote extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            toggleCheckbox: action,
            todosProcessosComAlertaImpeditivo: computed,
            pautaExclusivamenteVirtual: computed,
            pautaExclusivamentePresencial: computed,
            temInconsistenciaTipoJulgamento: computed,
            handleClickPublicar: action,
            larguraPadraoIcones: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get origemPJe() {
        return this.registro && this.registro.processo.origem === Configuracao.ORIGEM_PJE;
    }

    toggleCheckbox = () => {
        this.store.toggleCheckedOperacoesEmLote(this.registro);
    };

    get todosProcessosComAlertaImpeditivo() {
        return (
            this.observableProps.processos &&
            this.observableProps.alertasProcessos &&
            this.observableProps.processos.length ===
                this.observableProps.alertasProcessos.filter((alertaProcesso) =>
                    alertaProcesso.alertas.find((alerta) => alerta.impeditivo)
                ).length
        );
    }

    renderCheckboxAlerta() {
        if (this.observableProps.consulta) {
            return null;
        }
        let alertas = this.observableProps.alertasProcessos;
        if (alertas && alertas.length > 0) {
            let alertasProcesso = alertas.find(
                (alerta) => alerta.numeroProcesso === this.registro.processo.numeroCompleto
            );

            if (alertasProcesso?.alertas && alertasProcesso.alertas.length > 0) {
                return this.renderAlertasProcesso(alertasProcesso.alertas);
            }
        }
        return (
            <div>
                {this.renderCheckbox()}
                {alertas && alertas.length > 0 && <span style={{ marginRight: '32px' }} />}
            </div>
        );
    }

    renderAlertasProcesso(alertas) {
        let alertasImpeditivos = alertas.filter((alerta) => alerta.impeditivo);
        let alertasNaoImpeditivos = alertas.filter((alerta) => !alerta.impeditivo);
        let alertaComHandleClick = alertas.find((alerta) => alerta.handleClick);
        let handleClick = alertaComHandleClick?.handleClick;

        if (alertasImpeditivos.length > 0) {
            return (
                <Tooltip
                    placement="top"
                    title={this.getTooltipAlertas(alertas)}
                >
                    <Warning
                        style={{
                            fill: 'darkorange',
                            padding: this.todosProcessosComAlertaImpeditivo ? '0px 9px' : '0px 9px 0px 42px',
                            cursor: handleClick ? 'pointer' : 'default'
                        }}
                        onClick={this.handleClickProcesso(handleClick)}
                    />
                </Tooltip>
            );
        }

        return (
            <>
                {this.renderCheckbox()}
                <Tooltip
                    placement="top"
                    title={this.getTooltipAlertas(alertasNaoImpeditivos)}
                >
                    <Warning
                        style={{
                            fill: 'darkorange',
                            paddingRight: '8px',
                            cursor: handleClick ? 'pointer' : 'default'
                        }}
                        onClick={this.handleClickProcesso(handleClick)}
                    />
                </Tooltip>
            </>
        );
    }

    handleClickProcesso(handleClick) {
        return handleClick ? () => handleClick(this.registro) : undefined;
    }

    getTooltipAlertas(alertas) {
        return (
            <div>
                <div style={{ marginBottom: '8px' }}>Alertas:</div>
                {alertas.map((alerta) => (
                    <li
                        key={this.nextKey}
                        style={{ listStyleType: 'circle' }}
                    >
                        {alerta.mensagem}
                    </li>
                ))}
            </div>
        );
    }

    processoConfirmado() {
        this.store.checkOperacoesEmLote(this.registro);
        return this.store.isCheckedOperacoesEmLote(this.registro);
    }

    checkBoxPauta() {
        return this.registro.confirmadaInclusaoPauta ? (
            <Checkbox
                disabled
                checked={this.processoConfirmado()}
                onChange={this.toggleCheckbox}
                style={{ padding: '0px 9px' }}
            />
        ) : (
            <Checkbox
                checked={this.store.isCheckedOperacoesEmLote(this.registro)}
                onChange={this.toggleCheckbox}
                style={{ padding: '0px 9px' }}
            />
        );
    }

    renderWarning() {
        let titulo;

        if (this.pautaExclusivamenteVirtual) {
            titulo = 'Não é possível confirmar/publicar processo presencial em uma pauta virtual';
        } else {
            titulo = 'Não é possível confirmar/publicar processo virtual em uma pauta exclusivamente presencial';
        }

        return (
            <div>
                <Tooltip title={titulo}>
                    <Warning style={{ fill: 'darkorange', marginRight: '10px', marginLeft: '10px' }}></Warning>
                </Tooltip>
            </div>
        );
    }

    get pautaExclusivamenteVirtual() {
        return (
            this.sessaoStore.sessaoSelecionada &&
            this.sessaoStore.sessaoSelecionada.tipoJulgamento === MEIO_JULGAMENTO_SESSAO.VIRTUAL.codigo
        );
    }

    get pautaExclusivamentePresencial() {
        return SituacaoJulgamentoProcessoBusiness.isJulgamentoExclusivamentePresencial(
            this.sessaoStore?.sessaoSelecionada
        );
    }

    get temInconsistenciaTipoJulgamento() {
        return (
            (this.pautaExclusivamenteVirtual &&
                this.registro.tipoJulgamento === MEIO_JULGAMENTO_PROCESSO.PRESENCIAL.codigo) ||
            (this.pautaExclusivamentePresencial &&
                this.registro.tipoJulgamento !== MEIO_JULGAMENTO_PROCESSO.PRESENCIAL.codigo)
        );
    }

    renderCheckbox() {
        if (this.observableProps.publicarPauta) {
            if (this.temInconsistenciaTipoJulgamento) {
                return this.renderWarning();
            }

            return this.checkBoxPauta();
        }

        return (
            <Checkbox
                checked={this.store.isCheckedOperacoesEmLote(this.registro)}
                onChange={this.toggleCheckbox}
                style={{ padding: '0px 9px' }}
            />
        );
    }

    handleClickPublicar = () => {
        this.registro.checkedPublicacaoPauta = !this.registro.checkedPublicacaoPauta;
    };

    render() {
        const possuiSequencialPreferencia = this.registro?.pedidoSustentacaoOral?.sequenciaDigitacao
            ? this.registro.pedidoSustentacaoOral.sequenciaDigitacao
            : undefined;

        return (
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', padding: '6px 0px' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {this.renderCheckboxAlerta()}
                    {this.isSalaSessao && (
                        <span style={{ marginRight: '5px' }}>
                            <Apregoar registro={this.registro} />
                        </span>
                    )}
                    <span
                        style={{
                            width: '350px',
                            marginRight: '8px',
                            cursor: this.observableProps.consulta ? 'default' : 'pointer'
                        }}
                    >
                        <LabelNumeroProcesso
                            habilitarCopiarNumero
                            registro={this.registro}
                        />
                    </span>
                </div>
                {this.observableProps.publicarPauta && this.renderPublicar()}
                <div style={{ minWidth: this.observableProps.consulta ? '0px' : '320px' }}>
                    <IconesMagistradosProcesso registro={this.registro} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', minWidth: '60px' }}>
                    {this.origemPJe && (
                        <Tooltip title="Número de inclusão em pauta">
                            <Typography
                                variant="h6"
                                style={{ fontSize: '12pt', whiteSpace: 'nowrap', cursor: 'default' }}
                            >
                                {this.registro.informacoesAdicionais.NumeroPauta === '0'
                                    ? ''
                                    : this.registro.informacoesAdicionais.NumeroPauta}
                            </Typography>
                        </Tooltip>
                    )}
                </div>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        minWidth: this.observableProps.consulta ? '0px' : '40px'
                    }}
                >
                    <SustentacaoOral registro={this.registro} />
                </div>
                <div style={{ minWidth: '40px' }}>
                    {this.origemPJe ? (
                        this.registro.preferencia && <IconeAdvogadoPreferencia />
                    ) : (
                        <Tooltip title="Sequencial de preferência original">
                            <Typography
                                variant="h6"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: '12pt',
                                    whiteSpace: 'nowrap',
                                    justifyContent: 'center',
                                    cursor: 'default',
                                    color: grey[900],
                                    opacity: '0.8'
                                }}
                            >
                                {possuiSequencialPreferencia}
                            </Typography>
                        </Tooltip>
                    )}
                </div>
                {this.renderAnotacoes()}
                {this.renderOrdenacaoSecretario()}
                <div
                    style={{
                        marginLeft: '5px',
                        display: 'flex',
                        alignItems: 'center',
                        minWidth: this.observableProps.consulta ? '0px' : '36px'
                    }}
                >
                    {this.parametroStore.isOrgaoTST && <IconeOrigem processo={this.registro.processo} />}
                </div>
                <div style={{ minWidth: this.larguraPadraoIcones, marginLeft: this.margemPadraoIcones }}>
                    {this.registro?.informacaoProcessoSalaSessao?.magistradoVistaEmMesa && (
                        <Tooltip
                            title={
                                'Vista em mesa: ' +
                                this.registro.informacaoProcessoSalaSessao.magistradoVistaEmMesa.sigla
                            }
                        >
                            <VistaMesa style={{ fillOpacity: '0.7', margin: '3px', color: blue[900] }} />
                        </Tooltip>
                    )}
                </div>
                <Impedimento registro={this.registro} />
                <div style={{ minWidth: this.larguraPadraoIcones, marginLeft: this.margemPadraoIcones }}>
                    <PeticoesPendentes registro={this.registro} />
                </div>
                <div style={{ minWidth: this.larguraPadraoIcones, marginLeft: this.margemPadraoIcones }}>
                    <IconeDestaque registro={this.registro} />
                </div>
                <div
                    style={{
                        minWidth: this.larguraPadraoIcones,
                        marginLeft: this.margemPadraoIcones,
                        cursor: 'pointer '
                    }}
                >
                    <IconeTipoJulgamento registro={this.registro} />
                </div>
                <div style={{ minWidth: this.larguraPadraoIcones, marginLeft: this.margemPadraoIcones }}>
                    <IconeCorreJunto processo={this.registro.processo} />
                </div>
                <div style={{ minWidth: this.larguraPadraoIcones, marginLeft: this.margemPadraoIcones }}>
                    <VotoNaoLiberado registro={this.registro} />
                </div>
                <div style={{ minWidth: this.larguraPadraoIcones, marginLeft: this.margemPadraoIcones }}>
                    <StatusMinuta registro={this.registro} />
                </div>
                <div style={{ minWidth: this.larguraPadraoIcones, marginLeft: this.margemPadraoIcones }}>
                    <ResultadoJulgamento registro={this.registro} />
                </div>
                <div style={{ minWidth: this.larguraPadraoIcones, marginLeft: this.margemPadraoIcones }}>
                    <IconeRessalva registro={this.registro} />
                </div>
                <div style={{ minWidth: this.larguraPadraoIcones, marginLeft: this.margemPadraoIcones }}>
                    <IconeDivergencia registro={this.registro} />
                </div>
                <div style={{ minWidth: this.larguraPadraoIcones, marginLeft: this.margemPadraoIcones }}>
                    <VotoRevogado registro={this.registro} />
                </div>
                <div style={{ width: '28px' }}>
                    <IconeSemInformacaoIntimacao registro={this.registro} />
                </div>
                {this.registro.confirmadaInclusaoPauta && (
                    <div style={{ minWidth: this.larguraPadraoIcones, marginLeft: this.margemPadraoIcones }}>
                        <Tooltip
                            title={'Inclusão confirmada em pauta/sessão'}
                            placement="top-start"
                        >
                            <PlaylistAddCheck style={{ width: '24px', height: '24px' }} />
                        </Tooltip>
                    </div>
                )}
            </div>
        );
    }

    renderPublicar() {
        if (!this.store.isCheckedOperacoesEmLote(this.registro) || this.temInconsistenciaTipoJulgamento) {
            return <div style={{ width: '116px' }}></div>;
        }
        if (this.registro.confirmadaPublicacaoPauta) {
            return <div style={{ width: '116px' }}>Já publicado</div>;
        }
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <FormControlLabel
                    label="Publicar"
                    style={{ height: '30px' }}
                    control={
                        <Checkbox
                            value={this.registro.checkedPublicacaoPauta}
                            onClick={this.handleClickPublicar}
                            checked={this.registro.checkedPublicacaoPauta}
                        />
                    }
                />
            </div>
        );
    }

    renderOrdenacaoSecretario() {
        return (
            <div>
                {this.parametroStore.isOrgaoTST && this.registro.sessaoId && (
                    <Tooltip title="Ordenação do Secretário">
                        <div
                            style={{
                                width: '65px',
                                minHeight: '30px',
                                padding: '5px',
                                fontSize: '14px',
                                boxSizing: 'border-box',
                                borderColor: 'rgba(0, 0, 0, 0.23)',
                                borderStyle: 'solid',
                                borderWidth: '1px',
                                borderRadius: '4px'
                            }}
                        >
                            {this.registro.informacaoProcessoSalaSessao.ordenacaoSecretario}
                        </div>
                    </Tooltip>
                )}
            </div>
        );
    }

    renderAnotacoes() {
        if (!this.registro?.sessaoId) {
            return null;
        }

        const possuiAnotacoes = this.registro.informacaoProcessoSalaSessao?.complementoAnotacoes && (
            <Tooltip title={'Anotações: ' + this.registro.informacaoProcessoSalaSessao.complementoAnotacoes}>
                <span>
                    <IconeAnotacoes style={{ fillOpacity: '0.4' }} />
                </span>
            </Tooltip>
        );

        return (
            <>
                <div style={{ marginLeft: '5px', minWidth: this.larguraPadraoIcones }}>{possuiAnotacoes}</div>
                <div style={{ marginRight: '8px' }}>
                    <Tooltip title="Anotação curta">
                        <div
                            style={{
                                width: '100px',
                                minHeight: '30px',
                                padding: '5px',
                                fontSize: '14px',
                                boxSizing: 'border-box',
                                borderColor: 'rgba(0, 0, 0, 0.23)',
                                borderStyle: 'solid',
                                borderWidth: '1px',
                                borderRadius: '4px'
                            }}
                        >
                            {this.registro.informacaoProcessoSalaSessao.anotacao}
                        </div>
                    </Tooltip>
                </div>
            </>
        );
    }

    get larguraPadraoIcones() {
        return this.observableProps.consulta ? '0px' : '30px';
    }

    get margemPadraoIcones() {
        return '4px';
    }
}

export default inject('stores')(observer(CabecalhoProcessoOperacoesEmLote));
